<template>
  <div class="place-container">
    <div class="head van-hairline--bottom">
      <div class="tit">会场数据中心</div>
      <div class="read-more" @click="$router.push({ name: 'StorePlaceData' })">
        更多
        <img :src="require('@/assets/setting/箭头1.svg')" alt="" />
      </div>
    </div>
    <div v-show="data.length" class="text-xxs px-2 pb-2">
      <div
        v-for="(item, index) in data"
        :key="item.signBrandId"
        class="flex justify-between"
      >
        <div>
          <span class="mr-2">{{ index + 1 }}</span
          ><span>{{ item.brandName }}</span>
        </div>
        <div style="color: #aeaeae">
          <span class="mr-2">{{ item.visitNum }}人访问</span
          ><span>{{ item.orderNum }}单成交</span>
        </div>
      </div>
    </div>
    <div v-show="!data.length" class="text-center text-xs text-gray pb-2">
      暂无数据
    </div>
  </div>
</template>

<script>
import { getBrandAccessLog } from "../webApi";
export default {
  data() {
    return { data: [] };
  },
  created() {
    getBrandAccessLog({ dateType: "today", bool: true }).then(({ data }) => {
      if (data.length > 5) {
        this.data = data.slice(0, 5);
      } else {
        this.data = data;
      }
    });
  },
};
</script>

<style lang="less" scoped>
.place-container {
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
  border-radius: 16px;
  margin-bottom: 16px;
  .head {
    display: flex;
    justify-content: space-between;
    padding: 20px 18px;
    .tit {
      font-size: 24px;
      line-height: 34px;
    }
    .read-more {
      font-size: 24px;
      line-height: 34px;
      align-items: center;
      display: flex;
      color: #aeaeae;
      img {
        display: inline-block;
        height: 18px;
        margin-left: 20px;
      }
    }
  }
}
</style>